module.exports = __webpack_public_path__ + "c789ea20a0f569d9d6a92d6d34f452a1.svg";